




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

interface TimeCount {
    type: 'm'|'h'|'d',
    count: number
  }

@Component
export default class TimeAgo extends Vue {
  @Prop([Date, String]) readonly date!: Date|string;

  readable: TimeCount | null = null;
  intervalId: null | ReturnType<typeof setTimeout> = null;

  get timeAgo () {
    if (!this.readable) { return ''; }
    const { type, count } = this.readable;
    switch (type) {
      case 'm':
        return this.$tc('component.time.ago.minute', count, { count });
      case 'h':
        return this.$tc('component.time.ago.hour', count, { count });
      case 'd':
        return this.$tc('component.time.ago.day', count, { count });
    }
  }

  get thresholdCrossed () {
    if (!this.readable) return false;
    const { type, count } = this.readable;
    return !(type === 'm' && count < 60);
  }

  created () {
    this.setup();
  }

  @Watch('date')
  setup () {
    this.updateTime();
    this.intervalId && clearInterval(this.intervalId);
    if (this.thresholdCrossed) return;
    const intervalId = setInterval(() => {
      this.updateTime();
      if (this.thresholdCrossed) {
        clearInterval(intervalId);
      }
    }, 5000);
    this.intervalId = intervalId;
  }

  updateTime () {
    this.readable = this.calculateTimeAgo() || null;
  }

  calculateTimeAgo (): TimeCount|undefined {
    const now = new Date().getTime();
    const requestCreated = new Date(this.date).getTime();
    let sAgo = (now - requestCreated) / 1000;
    let count = 0;

    if (sAgo < 120) { return { type: 'm', count: 1 }; }
    if (sAgo < 3600) {
      while (sAgo >= 60) { sAgo -= 60; count += 1; }
      return { type: 'm', count };
    }

    if (sAgo < 7200) { return { type: 'h', count: 1 }; }
    if (sAgo < 86400) {
      while (sAgo >= 3600) { sAgo -= 3600; count += 1; }
      return { type: 'h', count };
    }

    if (sAgo < 172800) { return { type: 'd', count: 1 }; }
    if (sAgo > 172800) {
      count = Math.floor(sAgo / 86400);
      return { type: 'd', count };
    }
  }
}
